import { lookupCard } from "../../content/index.js";
import { applyCardEffects } from "../cards/applyEffect.js";
import { accept, reject } from "../reducer/reject.js";
import type { CardInstanceId, GameState, RunState } from "../types/index.js";
import { resumeRepeat, withReshuffleLog } from "./completion.js";

type MeetingChoice = Extract<NonNullable<RunState["pendingChoice"]>, { kind: "meeting" }>;

export function toggleMeetingChoice(state: GameState, pending: MeetingChoice, id: CardInstanceId): GameState {
  const target = state.run!.hand.find((card) => card.instanceId === id);
  if (!target || lookupCard(target.cardId)?.type !== "action") {
    return reject(state, "施策カードを選択してください");
  }
  return accept({ ...state, run: { ...state.run!, pendingChoice: { ...pending, targetInstanceId: id } } });
}

export function submitMeetingChoice(state: GameState, pending: MeetingChoice): GameState {
  const run = state.run!;
  if (!pending.targetInstanceId) return accept({ ...state, run: resumeRepeat({ ...run, pendingChoice: null }) });
  const target = run.hand.find((card) => card.instanceId === pending.targetInstanceId);
  if (!target || !run.activeCase) return reject(state, "選択対象外のカード");
  const definition = lookupCard(target.cardId);
  if (!definition?.effect) return reject(state, "施策カードを選択してください");
  const initialRun = {
    ...run,
    hand: run.hand.filter((card) => card.instanceId !== target.instanceId),
    inPlay: [...run.inPlay, target],
    pendingChoice: null,
    pendingRepeat: { target, remaining: pending.times - 1 },
  };
  const result = applyCardEffects({ run: initialRun, activeCase: run.activeCase, sourceInstanceId: target.instanceId }, definition.effect);
  const next = result.run.pendingChoice
    ? { ...result.run, activeCase: result.activeCase }
    : resumeRepeat({ ...result.run, activeCase: result.activeCase });
  return accept({ ...state, run: withReshuffleLog(run, next, result.reshuffled) });
}
